import type { JobSource } from '@chukua/common';

/** Display labels for `JOB_SOURCES` — the intake form's Source select and the missing-items list both read from this one map. */
export const JOB_SOURCE_LABELS: Record<JobSource, string> = {
  phone: 'Phone',
  whatsapp: 'WhatsApp',
  email: 'Email',
  release_order: 'Release order',
  walk_in: 'Walk-in',
};
